import dataLayer from './dataLayer'

function avatarMenuClick (linkName, linkUrl) {
  dataLayer.add({
    event : "headerNavigationSelect",
    linkName,
    context: "avatar",
    linkUrl: linkUrl && !/^https?:\/\//i.test(linkUrl) ? window.location.origin + linkUrl : linkUrl
  })
}

function menuClick (linkName, linkUrl) {
  dataLayer.add({
    event : "headerNavigationSelect",
    linkName,
    linkUrl: linkUrl && !/^https?:\/\//i.test(linkUrl) ? window.location.origin + linkUrl : linkUrl
  })
}
function onOpenHamburgarMenu () {
  dataLayer.add({
    event : 'topNavigationHamburgarMenuOpen',
    eventAction: 'Open'
  })
}

function topNavLayout (size) {
  dataLayer.add({
    topNavLayout : size
  })
}

function logoClick () {
  dataLayer.add({
    event : 'topNavigation',
    eventAction : 'Hem',
    target : 'klickat på logga'
  })
}

function topNavStoreLink (url) {
  dataLayer.add({
    event : 'topNavigationTopLink',
    targetUrl: url
  })
}

function openedSearch () {
  dataLayer.add({
    event : "headerNavigationSelect",
    linkName: "sökfunktion",
    linkUrl: ""
  })
}

function selectedStore (store) {
  dataLayer.add({
    event: 'selectedStoreLoaded',
    storeInformation: store || undefined
  })
}

function selectStore () {
  dataLayer.add({
    event: 'selectStoreSelectYourStore'
  })
}

function toggleSelectNewStore (openState) {
  const toggleState = openState ? 'selectStoreOpenDropdown' : 'selectStoreCloseDropdown'
  dataLayer.add({
    event: toggleState
  })
}

function changeOrGoToStore (button, store) {
  button === 'changeStore' ? dataLayer.add({
    event: 'selectStoreChangeStore'
  }) : dataLayer.add({
    event: 'selectStoreGoToStore',
    storeInformation:{
      id: store.storeId.startsWith("0") ? store.storeId.substring(1) : store.storeId,
      name: store.storeName.toLowerCase(),
      profile: store.profile?.toLowerCase()
    },
    linkName: "gå till butik",
    linkUrl: !/^https?:\/\//i.test(store.LinkToWeb) ? window.location.origin + store.LinkToWeb : store.LinkToWeb,
  })
}

function storeSearch (showMore, query, results) {
  showMore ? dataLayer.add({
    event: 'selectStoreSearchShowMore'
  }) : dataLayer.add({
    event: 'selectStoreSearch',
    results: results,
    searchTerm: query
  })
}

function selectNewStore (store, tab) {
  dataLayer.add({
    event: 'selectStore',
    context: tab,
    storeInformation: {
      id: store.Id.toString(),
      name: store.Name.toLowerCase(),
      profile: store.ShortProfileName?.toLowerCase()
    }
  })
}

function storeCloseToMe () {
  dataLayer.add({
    event: 'selectStoreCloseToMe'
  })
}

export default {
  avatarMenuClick,
  menuClick,
  topNavLayout,
  onOpenHamburgarMenu,
  topNavStoreLink,
  openedSearch,
  logoClick,
  selectedStore,
  selectStore,
  changeOrGoToStore,
  storeSearch,
  storeCloseToMe,
  selectNewStore,
  toggleSelectNewStore
}
